import React, { useState } from "react";
import SingleQuestion from "./SingleQuestion";
import { faq } from "./utils";
import PageHeaderSmall from "../PageHeaderSmall";

const FaqTwo = () => {
  const [question, setQuestion] = useState(faq);
  const title = "Frequent Asked Questions";
  return (
    <>
      <PageHeaderSmall title={title} />
      <section className="faqtwo section-wrapper">
        {question.map((item) => {
          return <SingleQuestion key={item.id} {...item} />;
        })}
      </section>
    </>
  );
};

export default FaqTwo;
